import React, { useState } from 'react';
import API from '../utils/api';

export default function StreakShieldUI({ freezeTokens = 0, canRepair = false, currentStreak = 0, onUpdate }) {
  const [freezing, setFreezing] = useState(false);
  const [repairing, setRepairing] = useState(false);
  const [message, setMessage] = useState('');

  const useFreeze = async () => {
    if (freezeTokens < 1) return;
    setFreezing(true);
    setMessage('');
    try {
      const res = await API.post('/streaks/freeze');
      setMessage(res.data.message || 'Streak saved!');
      if (onUpdate) onUpdate();
    } catch (err) {
      setMessage(err.response?.data?.message || 'Failed to use freeze.');
    } finally {
      setFreezing(false);
    }
  };

  const repairStreak = async () => {
    setRepairing(true);
    setMessage('');
    try {
      const res = await API.post('/streaks/repair');
      setMessage(res.data.message || 'Streak restored!');
      if (onUpdate) onUpdate();
    } catch (err) {
      setMessage(err.response?.data?.message || 'Cannot repair streak.');
    } finally {
      setRepairing(false);
    }
  };

  if (freezeTokens < 1 && !canRepair) return null;

  return (
    <div className="mt-3 p-3 rounded-3" style={{ background: 'var(--item-bg)', border: '1px solid var(--border-purple)' }}>
      {message && (
        <div className="alert alert-success py-1 px-2 small rounded-2 mb-2">{message}</div>
      )}

      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
        {freezeTokens > 0 && (
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontSize: '20px' }}>🧊</span>
            <div>
              <div className="fw-semibold small" style={{ color: 'var(--text-main)' }}>Streak Freeze</div>
              <div className="text-muted" style={{ fontSize: '11px' }}>{freezeTokens} token{freezeTokens > 1 ? 's' : ''} available</div>
            </div>
            <button className="btn btn-sm rounded-pill ms-2"
              style={{ background: 'rgba(37,99,235,0.12)', color: '#3b82f6', border: '1px solid rgba(37,99,235,0.3)', fontSize: '12px' }}
              onClick={useFreeze} disabled={freezing}>
              {freezing ? '…' : 'Use Freeze'}
            </button>
          </div>
        )}

        {canRepair && (
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontSize: '20px' }}>🔧</span>
            <div>
              <div className="fw-semibold small" style={{ color: 'var(--text-main)' }}>Repair Streak</div>
              <div className="text-muted" style={{ fontSize: '11px' }}>Restore your {currentStreak}-night streak</div>
            </div>
            <button className="btn btn-sm rounded-pill ms-2"
              style={{ background: 'rgba(234,88,12,0.12)', color: '#ea580c', border: '1px solid rgba(234,88,12,0.3)', fontSize: '12px' }}
              onClick={repairStreak} disabled={repairing}>
              {repairing ? '…' : 'Repair'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
